import { OfficeBuildingCogOutlineIcon } from './OfficeBuildingCogOutlineIcon';

/**
 * author: Joshua Solomon
 * id 09BF7DAE-15CA-4539-BD8A-A741EB7E6405
 * name office-building-cog-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/office-building-cog-outline.svg
 * tags
 * - Settings 
 * - Places 
 */
export const OfficeBuildingSettingsOutlineIcon = OfficeBuildingCogOutlineIcon;
export default OfficeBuildingSettingsOutlineIcon